<template>
    <div class="order-page">
        <!-- 页面标题 -->
        <div class="custom-header">
            <div class="back-btn" @click="goBack">
                <span class="icon">←</span>
            </div>
            <div class="header-title">提交订单</div>
            <div class="share-btn">
            </div>
        </div>

        <!-- 收货地址 -->
        <div class="address-section">
            <div class="address-content">
                <div class="address-header">
                    <img src="/static/confirm/dizhi.png" alt="" style="width: 14px;height: 14px;margin: 6px;">
                    <div class="address-text">
                        <div>地址地址地址地址地址地址地址地址</div>
                        <div class="user-info">
                            <span class="name">刘先生</span>
                            <span class="phone">13458796216</span>
                        </div>
                    </div>
                </div>
                <div>
                    <img src="/static/confirm/xiugai.png" alt="" style="width: 16px;height: 16px;">
                </div>
            </div>

        </div>

        <!-- 商品信息 -->
        <div class="product-section">
            <div class="product-content">
                <div class="product-image">
                    <!-- 电饭煲图片占位 -->
                    <img src="/static/confirm/shopimg.png" alt="" class="image-placeholder">
                </div>
                <div class="product-details">
                    <div class="product-name">荣事达电饭煲</div>
                    <div class="product-additional">详情描述详情描述详情描述</div>
                    <div class="product-price">
                        <div>
                            <span class="integral">52积分<span class="price">+￥<span
                                        style="font-size: 18px;">0</span>.01/份</span></span>

                        </div>
                        <div class="num-box">
                            <div class="num-btn" @click="decreaseNum">-</div>
                            <input type="number" class="num-input" v-model="quantity" min="1" />
                            <div class="num-btn" @click="increaseNum">+</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 配送与售后 -->
            <div class="delivery-section">
                <div class="delivery-item">
                    <span class="label">配送</span>
                    <span class="value">快递 包邮 3天内发货 ></span>
                </div>
                <div class="delivery-item">
                    <span class="label">退货权益</span>
                    <span class="value">退换货免首重运费 ></span>
                </div>
                <div class="delivery-item">
                    <span class="label">备注</span>
                    <span class="value">无备注 ></span>
                </div>
            </div>
        </div>


        <!-- 金额明细 -->
        <div class="amount-section">
            <div class="amount-details">
                <div class="amount-item">
                    <span class="label">商品金额</span>
                    <span class="value">￥{{ formatPrice(productAmount) }}</span>
                </div>
                <div class="amount-item discount">
                    <span class="label"><span>店铺优惠券</span> <span class="label-box">最佳优惠</span></span>
                    <span class="value">-￥12 ></span>
                </div>
                <div class="amount-item first-buy">
                    <span class="label">首购优惠券</span>
                    <span class="value">￥0 ></span>
                </div>
                <div class="amount-item discount">
                    <span class="label"><span>积分兑换</span> <span class="label-box">新客折上5折</span></span>
                    <span class="value">-52 ></span>
                </div>
                <div class="amount-total">
                    <span class="label">小计</span>
                    <span class="value">￥{{ formatPrice(totalAmount) }}</span>
                </div>
            </div>
        </div>

        <!-- 支付方式 -->
        <div class="payment-section">
            <div class="payment-options">
                <div class="payment-option" @click="selectPayment('wechat')">
                    <div class="payment-icon wechat"><img src="/static/confirm/wechat.png" alt=""
                            style="width: 16px;height: 16px;margin-right: 8px;"> <span class="payment-name">微信</span>
                    </div>
                    <div class="payment-check">
                        <!-- 修改这里：使用图片代替字符 -->
                        <img v-if="selectedPayment === 'wechat'" src="/static/confirm/check.png" alt="">
                        <img v-else src="/static/confirm/check-no.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部支付栏 -->
        <div class="footer">
            <div class="footer-content">
                <div class="total-amount">
                    <span class="total-price"><span style="font-size: 14px;">￥</span>{{ formatPrice(totalAmount)
                        }}</span>
                </div>
                <div class="action-buttons">
                    <button class="btn-help-pay">找人付</button>
                    <button class="btn-pay-now" @click="handlePayment">立即支付</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderPage',
    data() {
        return {
            quantity: 1,
            selectedPayment: 'wechat',
            productPrice: 35.7,
            couponDiscount: 12,
            integralDiscount: 0.52
        }
    },
    computed: {
        productAmount() {
            return this.productPrice * this.quantity;
        },
        totalAmount() {
            let total = this.productAmount - this.couponDiscount - this.integralDiscount;
            return total > 0 ? total : 0.01; // 最低0.01元
        }
    },
    methods: {
        decreaseNum() {
            if (this.quantity * 1 > 1) {
                this.quantity--;
            }
        },
        increaseNum() {
            this.quantity++;
        },
        goBack() {
            window.history.back();
        },

        selectPayment(method) {
            this.selectedPayment = method;
        },
        formatPrice(price) {
            return parseFloat(price).toFixed(2);
        },
        handlePayment() {
            this.$router.push('/order');
        }
    }
}
</script>

<style scoped>
.custom-header {
    position: sticky;
    top: 0;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background-color: #fff;
    border-bottom: 1px solid #f0f0f0;
}


.back-btn,
.share-btn {
    cursor: pointer;
    font-size: 16px;
    color: #333;
}

.header-title {
    font-size: 17px;
    font-weight: 500;
}

.back-btn .icon {
    font-size: 24px;
}


/* 基础样式 */
.order-page {
    font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif;
    background-color: #f5f5f5;
    min-height: 100vh;
    padding-bottom: 30px;
    color: #333;
}

/* 状态栏 */
.status-bar {
    background-color: #fff;
    padding: 10px 15px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid #eee;
}

/* 页面标题 */
.header {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    border-bottom: 1px solid #eee;
}

.header .title {
    font-size: 18px;
    font-weight: 600;
}

/* 收货地址 */
.address-section {
    background-color: #fff;
    margin-top: 10px;
    padding: 15px;
    border-bottom: 1px solid #f0f0f0;
}

.address-content {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.address-header {
    display: flex;
}

.address-text {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
}

.address-label {
    font-size: 16px;
    font-weight: 500;
}

.address-icon {
    color: #999;
    font-size: 18px;
}

.user-info {
    margin-bottom: 8px;
    text-align: left;
}

.user-info .name {
    font-size: 16px;
    font-weight: 500;
    margin-right: 12px;
}

.user-info .phone {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    text-align: left;
}

.address-detail {
    font-size: 14px;
    color: #666;
    line-height: 1.4;
}

/* 商品信息 */
.product-section {
    background-color: #fff;
    margin: 10px;
    padding: 15px 15px 10px;
    border-radius: 8px 8px 8px 8px;
}

.product-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
}

.product-content {
    display: flex;
}

.product-image {
    width: 81px;
    height: 81px;
    margin-right: 15px;
}

.image-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 12px;
}

.product-details {
    flex: 1;
    text-align: left;
}

.product-name {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 5px;
}

.product-desc {
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;
}

.product-additional {
    font-size: 12px;
    color: #999;
    margin-bottom: 10px;
}

.product-price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
}

.integral {
    font-size: 16px;
    color: #e4393c;
    margin-right: 10px;
}

.price {
    font-size: 12px;
    color: #e4393c;
    font-weight: 500;
    text-align: left;
}

.quantity-control {
    display: flex;
    align-items: center;
    width: 120px;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
}

.btn-minus,
.btn-plus {
    width: 36px;
    height: 36px;
    background-color: #f8f8f8;
    border: none;
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.btn-minus:active,
.btn-plus:active {
    background-color: #e0e0e0;
}

.quantity {
    flex: 1;
    text-align: center;
    font-size: 16px;
}

.num-box {
    display: flex;
    align-items: center;
}

.num-btn {
    width: 20px;
    height: 20px;
    border: 1px solid #C4C4C4;
    line-height: 20px;
    color: #000000;
    font-size: 12px;
    text-align: center;
}

.num-input {
    width: 40px;
    height: 20px;
    text-align: center;
    color: #000000;
    font-size: 12px;
    border: 1px solid #C4C4C4;
    padding: 0;
}

/* 配送与售后 */
.delivery-section {
    background-color: #fff;
    margin-top: 10px;
    padding: 15px 0 0;
}

.delivery-item {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
}

.delivery-item:last-child {
    border-bottom: none;
}

.delivery-item .label {
    font-size: 14px;
    color: #000000;
}

.delivery-item .value {
    font-size: 12px;
    color: #000000;
}

/* 金额明细 */
.amount-section {
    background-color: #fff;
    margin: 10px;
    padding: 15px;
    border-radius: 8px 8px 8px 8px;
}

.amount-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
}

.amount-item {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    font-size: 14px;
}

.amount-item .label {
    font-size: 14px;
    color: #000000;
    display: flex;
    align-items: center;
}

.amount-item .label-box {
    height: 16px;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #FF0000;
    padding: 0 4px;
    line-height: 16px;
    text-align: center;
    font-size: 9px;
    color: #FF0000;
    margin-left: 8px;
}

.amount-item.first-buy .value {
    color: #9F9F9F;
}

.amount-item.discount .value {
    color: #e4393c;
}

.amount-total {
    display: flex;
    justify-content: space-between;
    padding: 15px 0 5px;
    font-size: 16px;
    font-weight: 500;
    border-top: 1px solid #f0f0f0;
    margin-top: 5px;
}

.amount-total .value {
    color: #e4393c;
}

/* 支付方式 */
.payment-section {
    background-color: #fff;
    margin-top: 10px;
    padding: 15px;
}

.payment-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
}

.payment-options {
    border-radius: 8px;
    overflow: hidden;
}

.payment-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.payment-icon {
    display: flex;
    align-items: center;
    justify-content: center;
}

.payment-name {
    font-size: 16px;
    flex: 1;
}

.payment-check {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.payment-check img {
    width: 16px;
    height: 16px;
}

/* 底部支付栏 */
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 15px;
    z-index: 100;
}

.footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.total-amount {
    display: flex;
    align-items: baseline;
}

.total-label {
    font-size: 14px;
    color: #666;
    margin-right: 8px;
}

.total-price {
    font-size: 22px;
    font-weight: 600;
    color: #e4393c;
}

.action-buttons {
    display: flex;
    height: 43px;
    border-radius: 22px;
    overflow: hidden;
}

.btn-help-pay {
    height: 43px;
    background: #FFEFEF;
    border-radius: 22px 0 0 22px;
    font-size: 14px;
    color: #FF0000;
    font-weight: 700;
    border: none;
    padding: 0 20px;
    cursor: pointer;
    white-space: nowrap;
}

.btn-pay-now {
    height: 43px;
    background: linear-gradient(0deg, #FD5325 0%, #FE2629 100%);
    border-radius: 0 22px 22px 0;
    font-size: 14px;
    color: #FFEFEF;
    font-weight: 700;
    border: none;
    padding: 0 24px;
    cursor: pointer;
    white-space: nowrap;
}

/* 响应式调整 */
@media (max-width: 375px) {
    .total-price {
        font-size: 20px;
    }

    .btn-help-pay {
        padding: 0 18px;
    }

    .btn-pay-now {
        padding: 0 20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Confirm.vue